module.exports = __webpack_public_path__ + "static/img/nao_editavel.f0ca7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nao_editavel.png
// module id = R99P
// module chunks = 1